import { Injectable } from '@angular/core';
import { UrlUtils } from '../common/utils/url-utils';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Mockable } from '../mocks/mockable.decorator';

/* eslint-disable @typescript-eslint/naming-convention */
export interface StripeSubscription {
    id: string;
    object: string;
    application_fee_percent: number | null;
    billing_cycle_anchor: number;
    billing_thresholds: number | null;
    cancel_at: Date;
    cancel_at_period_end: boolean;
    canceled_at: Date;
    collection_method: string;
    status: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

@Injectable({
    providedIn: 'root'
})
@Mockable
export class DeckplanStripeService {

    private readonly backendUrl = UrlUtils.constructBackendUrl('stripe');

    constructor(private readonly http: HttpClient) {
    }

    public createSubscription(customerId: string, paymentMethodId: string, priceId: string, userId: number): Observable<StripeSubscription> {
        return this.http.post<StripeSubscription>(`${this.backendUrl}/subscriptions`, {customerId, paymentMethodId, priceId, userId});
    }

    public cancelSubscription(userId: number): Observable<StripeSubscription> {
        return this.http.delete<StripeSubscription>(`${this.backendUrl}/subscriptions/${userId}`);
    }

    public updatePaymentMethod(userId: number, paymentMethodId: string): Observable<StripeSubscription> {
        return this.http.put<StripeSubscription>(`${this.backendUrl}/payment-method/${userId}`, {paymentMethodId});
    }
}
